import * as ambassadorWixBlogV3Category from './blog-v3-category-categories.http.js';
import * as ambassadorWixBlogV3CategoryTypes from './blog-v3-category-categories.types.js';
import * as ambassadorWixBlogV3CategoryUniversalTypes from './blog-v3-category-categories.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCategory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3CategoryUniversalTypes.CreateCategoryRequest,
  ambassadorWixBlogV3CategoryTypes.CreateCategoryRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.CreateCategoryResponse,
  ambassadorWixBlogV3CategoryTypes.CreateCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Category.createCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCategory(): __PublicMethodMetaInfo<
  'PATCH',
  { categoryId: string },
  ambassadorWixBlogV3CategoryUniversalTypes.UpdateCategoryRequest,
  ambassadorWixBlogV3CategoryTypes.UpdateCategoryRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.UpdateCategoryResponse,
  ambassadorWixBlogV3CategoryTypes.UpdateCategoryResponse
> {
  const payload = { category: { id: ':categoryId' } } as any;

  const getRequestOptions = ambassadorWixBlogV3Category.updateCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/categories/{category.id}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCategory(): __PublicMethodMetaInfo<
  'GET',
  { categoryId: string },
  ambassadorWixBlogV3CategoryUniversalTypes.GetCategoryRequest,
  ambassadorWixBlogV3CategoryTypes.GetCategoryRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.GetCategoryResponse,
  ambassadorWixBlogV3CategoryTypes.GetCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Category.getCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCategoryBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixBlogV3CategoryUniversalTypes.GetCategoryBySlugRequest,
  ambassadorWixBlogV3CategoryTypes.GetCategoryBySlugRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.GetCategoryBySlugResponse,
  ambassadorWixBlogV3CategoryTypes.GetCategoryBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions =
    ambassadorWixBlogV3Category.getCategoryBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/categories/slugs/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCategories(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3CategoryUniversalTypes.ListCategoriesRequest,
  ambassadorWixBlogV3CategoryTypes.ListCategoriesRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.ListCategoriesResponse,
  ambassadorWixBlogV3CategoryTypes.ListCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Category.listCategories(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCategories(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3CategoryUniversalTypes.QueryCategoriesRequest,
  ambassadorWixBlogV3CategoryTypes.QueryCategoriesRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.QueryCategoriesResponse,
  ambassadorWixBlogV3CategoryTypes.QueryCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Category.queryCategories(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/categories/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCategory(): __PublicMethodMetaInfo<
  'DELETE',
  { categoryId: string },
  ambassadorWixBlogV3CategoryUniversalTypes.DeleteCategoryRequest,
  ambassadorWixBlogV3CategoryTypes.DeleteCategoryRequest,
  ambassadorWixBlogV3CategoryUniversalTypes.DeleteCategoryResponse,
  ambassadorWixBlogV3CategoryTypes.DeleteCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Category.deleteCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Category as CategoryOriginal,
  PageUrl as PageUrlOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  CategoryTranslation as CategoryTranslationOriginal,
  InitialCategoriesCopied as InitialCategoriesCopiedOriginal,
  CreateCategoryRequest as CreateCategoryRequestOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  CreateCategoryResponse as CreateCategoryResponseOriginal,
  BulkCreateCategoriesRequest as BulkCreateCategoriesRequestOriginal,
  BulkCreateCategoriesResponse as BulkCreateCategoriesResponseOriginal,
  BulkCategoryResult as BulkCategoryResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateCategoriesRequest as BulkUpdateCategoriesRequestOriginal,
  MaskedCategory as MaskedCategoryOriginal,
  BulkUpdateCategoriesResponse as BulkUpdateCategoriesResponseOriginal,
  UpdateCategoryRequest as UpdateCategoryRequestOriginal,
  UpdateCategoryResponse as UpdateCategoryResponseOriginal,
  GetCategoriesCountByLanguageRequest as GetCategoriesCountByLanguageRequestOriginal,
  GetCategoriesCountByLanguageResponse as GetCategoriesCountByLanguageResponseOriginal,
  CategoryLanguageCount as CategoryLanguageCountOriginal,
  GetCategoryRequest as GetCategoryRequestOriginal,
  GetCategoryResponse as GetCategoryResponseOriginal,
  GetCategoryBySlugRequest as GetCategoryBySlugRequestOriginal,
  GetCategoryBySlugResponse as GetCategoryBySlugResponseOriginal,
  ListCategoriesRequest as ListCategoriesRequestOriginal,
  BlogPaging as BlogPagingOriginal,
  ListCategoriesResponse as ListCategoriesResponseOriginal,
  MetaData as MetaDataOriginal,
  QueryCategoriesRequest as QueryCategoriesRequestOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryCategoriesResponse as QueryCategoriesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  BulkDeleteCategoryRequest as BulkDeleteCategoryRequestOriginal,
  BulkDeleteCategoryResponse as BulkDeleteCategoryResponseOriginal,
  DeleteCategoryRequest as DeleteCategoryRequestOriginal,
  DeleteCategoryResponse as DeleteCategoryResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './blog-v3-category-categories.types.js';
